module.exports = __webpack_public_path__ + "7845bd438083af20af988a0852c84ee0.svg";


//////////////////
// WEBPACK FOOTER
// ./images/unarchive-icon.svg
// module id = 82
// module chunks = 0